
function inputFields() {
  $(document).on('input','.InputGroup input', function () {
    let $inputs = $(this).parents(".js-form-inputs").find('input');
    const $submitBtn = $(this).parents(".js-form-parent").find('.js-form-submit');
    let inputsLength = $inputs.length
    let i = 0
    $inputs.each(function () {
      if($(this).val()) {
        i++
        if($(this).val() && inputsLength === i) {
          $submitBtn.addClass('ActiveBtn')
        }
      }  else {
        $submitBtn.removeClass('ActiveBtn')
      }
    })
  })
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const defaultTo = function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }

  let value = '';
  let currencyIcon = '$';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = (format || moneyFormat);

  switch (Shopify.currency.active) {
    case 'GBP':
      currencyIcon = '£';
      break;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const thousandsCount = Math.trunc(cents / 100000)
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `${thousandsCount}` + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', '.');
      break;
  }

  return currencyIcon + formatString.replace(placeholderRegex, value);
}

function BirthdayInputValidate () {
  let slash = false
  let valLength = 0

  $(document).on('input','#birthday', function () {
    let $parent = $(this).parents(".js-form-parent");
    let $submitBtn = $parent.find(".js-form-submit");
    $parent.removeClass('dateInvalid')
    let val = $(this).val();

    if (!val) {
      return
    }

    if(val.length === 2 && !slash) {
      slash = true
      val += '/'
      $(this).val(val)
      valLength = val.length
    } else if (val.length+1 < valLength && slash){
      slash = false
    } else if(val.length === 3 && slash) {
      if (val.slice(-1) !== '/') {
        let newVal = '/' + val.slice(-1)
        val = val.slice(0, -1)
        val = val.concat(newVal)
        $(this).val(val)
      }
    }

    const returnedFunction = debounce(function () {
      let actualVal = $parent.find("#birthday").val()
      let re =  /^(0?[1-9]|1[0-2]){1}\/(0?[1-9]|1[0-9]|2[0-9]|3[0-1]){1}$/;
      let result = re.test(actualVal);

      if(!result && actualVal !== '') {
        $parent.addClass('dateInvalid');
        $submitBtn.attr('disabled', 'disabled');
      } else {
        $parent.removeClass('dateInvalid');
        $submitBtn.removeAttr('disabled', 'disabled');
      }
    }, 450)

    returnedFunction()

  })
}

function setMetafieldBirthday() {
  if (Accentuate)  Accentuate($("#SetMetafield"));

  let customer = $('[data-customer]');
  let customerId = customer.attr('data-customer');

  if (customerId && localStorage.getItem('birthday')) {
    let birthdayValue = localStorage.getItem('birthday');
    let hiddenBirthdayForm = $('#SetMetafield');
    let inputValue = hiddenBirthdayForm.find('input[type="text"]');

    inputValue.attr('value', birthdayValue);
    hiddenBirthdayForm.trigger( "submit" )
    localStorage.removeItem('birthday');
  }
}

function headerHeightVariable() {
  const headerHeight = $(document).find('header.Header').height();
  const body =  $(document).find('body');
  
  body.css('--header-height', headerHeight + "px" )

  $(window).on('scroll', debounce(function () {
    body.css('--header-height', headerHeight + "px" )
  }, 500) )
}

function anchorLinkScroll() {
  const $page = $('html, body');
  let headerHeight = $('header.Header').height();
  let announcementHeight = $('.Announcement-Bar__Wrapper')?.height() || 0;

  $('a[href*="#"]').not('.Faq__NavLink').click(function() {
    let offset = $($.attr(this, 'href')).offset().top - headerHeight - announcementHeight

    $page.animate({
      scrollTop: offset
    }, 400);
    return false;
  });

  if(location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - headerHeight);
  }
}

function shopAll() {
  var $shopAllSection = $(`section[data-collection="true"]`);
  var $allCollections = $shopAllSection.find('.ListCollection__CardItemWrapper[data-collection]');
  var $buttons = $shopAllSection.find('.ListCollection__CollectionListTitle');
  
  $buttons.on('click', function () {
    var _self = this;
    
    //style btn
    $buttons.removeClass('Active');
    $(this).addClass('Active');
    
    //change visible blocks
    $allCollections.fadeOut(0);
    AOS.refresh()
    
    $allCollections.each(function () {
      const $thisCollection = $(this).attr('data-collection')
      const $selfDataTitle = $(_self).attr("data-title")
     
      if ($thisCollection == $selfDataTitle || $(this).attr(`data-collection`).includes($selfDataTitle)) {
        $(this).fadeIn(0);
      } else if (!$selfDataTitle) {
        $allCollections.fadeIn(0);
      }
    })
  })
}

function initWidthMarquee() {
  setTimeout(function (){
  var $carousel = $('.Subhero__Promo')
  var $carouselElementsWrapper = $('.Subhero__PromoWrapper')
  var visibleElementIndex = Math.floor($carouselElementsWrapper.length / 2)
  var width = $carouselElementsWrapper.width()*visibleElementIndex - 1000
  $carousel.css('width', width)
  }, 1000)
}

function orientationDeviceListener() {
  window.addEventListener("orientationchange", function(event) {
    initWidthMarquee()
  });
}

//==============Header===========
function headerDriver() {
  const header = $('header.Header');
  const overlay = $('.Overlay');
  const body = $(document).find('body')
  const mobileMenu = header.find('.MobileMenu__Wrapper');
  const disableBodyScroll  =  bodyScrollLock.disableBodyScroll;
  const enableBodyScroll  =  bodyScrollLock.enableBodyScroll;
  let announcementBarHeight = $('.Announcement-Bar__Item').height();
  let headerHeight = header.height();
  let hasSticky = false;
  let announcementSticky = $('.Announcement-Bar__Wrapper').hasClass('AnnouncementBar--Sticky');

  function toggleMegaMenu(element, show) {
    const expanded = show ? 'true' : 'false';
    element.attr('aria-expanded', expanded);
    header.toggleClass('Active', show);
    overlay.toggleClass('Active', show);
  }

  function closeAllMegaMenus() {
    const megaMenus = header.find('.HasMegaMenu');
    megaMenus.attr('aria-expanded', 'false');
    header.removeClass('Active');
    overlay.removeClass('Active');
  }

  function setupAccessibleMenu(menuItem) {
    const $menuItem = $(menuItem);

    $menuItem.hover(
        () => toggleMegaMenu($menuItem, true),
        (e) => {
          if (!$menuItem[0].contains(e.relatedTarget)) {
            toggleMegaMenu($menuItem, false);
          }
        }
    );

    $menuItem.on('focusin', () => toggleMegaMenu($menuItem, true));

    $menuItem.on('focusout', (e) => {
      if (!$menuItem[0].contains(e.relatedTarget)) {
        toggleMegaMenu($menuItem, false);
      }
    });

    $menuItem.on('keydown', (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeAllMegaMenus();
      }
    });
  }

  header.find('.HasMegaMenu').each(function () {
    setupAccessibleMenu(this);
  });

  header.on('click', ".Nav__Control", function (e) {
    announcementBarHeight = $('.Announcement-Bar__Item').height();

    if ($(window).scrollTop() > announcementBarHeight && !announcementSticky) {
      announcementBarHeight = 0;
    }

    if ($(window).scrollTop() < announcementBarHeight && $(window).scrollTop() > 0 && !announcementSticky) {
      window.scrollTo(0 , 0);
      setTimeout(() => {header.addClass('StickyHeader')}, 200);
    }
    
    $(this).toggleClass('Active');
    header.toggleClass('OpenMobileMenu');
    mobileMenu.fadeToggle();


    mobileMenu.css('top', headerHeight + announcementBarHeight + 'px')


    if ($(this).hasClass('Active')){
      body.css('overflow-y', 'hidden');
      disableBodyScroll ( mobileMenu[0] );

      if (!header.hasClass('StickyHeader')) {
        header.addClass('StickyHeader');
        hasSticky = false;
      } else {
        hasSticky = true;
      }
    } else {
      body.css('overflow-y', 'auto');
      enableBodyScroll ( mobileMenu[0] );

      if (!hasSticky) {
        header.removeClass('StickyHeader');
      }
    }
  })

  header.on('click', '.MobileMenu__ItemButton', function () {
    header.find('.MobileMenu__ItemContent').not($(this).siblings('.MobileMenu__ItemContent')).slideUp().removeClass('Open');
    header.find('.MobileMenu__ItemButton').not($(this)).removeClass('Open');
    $(this).toggleClass('Open').siblings('.MobileMenu__ItemContent').slideToggle();
  })

  $(window).on('resize', function () {
    const control = header.find('.Nav__Control');
    const controlHasActive = control.hasClass('Active');

    if ($(this).width() > 1100 && controlHasActive ) {
      control.click();
    }
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > (announcementBarHeight + header.height())) {
      header.addClass('StickyHeader');
    } else {
      header.removeClass('StickyHeader');
    }
  })

}
//==============Header===========

//==============Popup===========
function popup() {
  const $newsletterPopup = $(".NewsletterPopup");
  const saveTime = +($newsletterPopup.attr("data-age-cookie"));
  const pause = +($newsletterPopup.attr("data-pause"));
  const nameCookie = 'avalinePopup';

  if (!Cookies.get('avalinePopup')) {
    setTimeout(function () {
      $newsletterPopup.fadeIn(0).addClass("is-active")
      Cookies.set(nameCookie, 'true', { expires : saveTime })
    }, pause)
  }

  $newsletterPopup.on('click', ".JsNewsletterPopupClose", function () {
    $newsletterPopup.fadeOut(0)
  } )
}
//==============Popup===========

//==============Product Card===========
function clickCardItems() {
  $(document).on('click', '.CardItem .QuickAdd', function(e) {
    if ($(window).width() > 767 && !$(this).attr('disabled')) {
      $(this).parents('.CardItem').find(".js.product-form__input").css("display", "flex");
    } else if (!$(this).attr('disabled')) {
      //open select o n IOS
      const select = $(this).siblings(".product-form__input-selected").find('select')[0];
      const event = new MouseEvent('mousedown');
      
      $(this).siblings(".product-form__input-selected").fadeIn(0);
      select.dispatchEvent(event);
    }
  })

  $(document).on('change', '.CardItem #selected-variant', function(e) {
    const $cardItem = $(this).parents('.CardItem');
 
    $cardItem.find(".product-form__submit.ButtonHasVariants").click();
    $cardItem.find(".js.product-form__input").hide();
    $cardItem.find('.product-form__input input[type="radio"]:checked').prop('checked', false);
  })
  
  $(document).on('change', '.CardItem .product-form__input-selected select', function(e) {
    const $cardItem = $(this).parents('.CardItem');
    const $thisOption = $(this).find("option:selected").attr("data-id");
    
    $cardItem.find("#" + $thisOption).click()
    $(this).parent().hide();
  })
}

function changeContentBySelector(selector, html) {
  const currentContent = document.querySelector(selector);
  const newContent = html.querySelector(selector);
  if (currentContent && newContent) currentContent.innerHTML = newContent.innerHTML;
}

function clickOutside() {
  $(document).mouseup(function(e) {
    var container = $(".CardItem .js.product-form__input");
    var containerSelect = $(".CardItem .product-form__input-selected");
    
    if (container.is(":visible") && !container.is(e.target) && container.has(e.target).length === 0)
    {
      container.hide();
    }
    
    if (containerSelect.is(":visible") && !containerSelect.is(e.target) && containerSelect.has(e.target).length === 0)
    {
      containerSelect.hide();
    }
    
  })
}

function yotpoReviews() {
  setTimeout(function () {
    $('.yotpo-bottomline').each(function (i) {
      $(this).find('.text-m').html('('+ $(this).find('.text-m').text().split(' Review')[0] + ')').toggleClass('text-m star-rating Body2');
      $(this).find('.yotpo-icon').attr('aria-hidden', true);
    })
  }, 3000);
}

//==============Product Card===========

function sliderInit() {
  $('[data-section-type="slideshow"]').each(function () {
    var config = JSON.parse($(this).attr('data-slider-config'));
    var breakpointsData = $(this).attr('data-breakpoint');
    const $slider = $(this)
    
    if (config && !$slider.hasClass('swiper-initialized')) {
      if (breakpointsData) {
        var breakpoint = window.matchMedia( `(${breakpointsData})` );
        const breakpointChecker = () => {
          if (breakpoint.matches === true ) {
            if ($slider.swiper) $slider.swiper.destroy( true, true )
          } else { new Swiper(this, config)}
        };
        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
      } else {
        new Swiper(this, config)
      }
    }
  });
}

// Email validation
function emailValidation() {
  $(document).on('input', "[type='email']", debounce(function () {
    const val = $(this).val();
    const $parent = $(this).parents(".js-form-parent");
    const $errorMessage = $parent.find('[aria-label="valid-email"]');
    
    if (val === '') {
      $errorMessage.hide()
      return
    }
  
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = re.test(val);
    
    if (!result && val !== '') {
      $errorMessage.show()
    } else {
      $errorMessage.hide()
    }
  }, 1000))
}
// Email validation

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class NewsLetterForm extends HTMLElement {
  constructor() {
    super();
    this.eventListener()
  }
  
  eventListener() {
    const $form = $(this).find('form')
    const $submitInputButton = $(this).find('[aria-label="button"]');
    const $newsLetterInput = $(this).find('input[type="email"]');
    const $inputError = $(this).find('[aria-label="input-error"]');
    const $validError = $(this).find('[aria-label="valid-error"]');
    const $serverError = $(this).find('[aria-label="server-error"]');
    const $successMessage = $(this).find('[aria-label="success-message"]');
    const $successText = $(this).find('[aria-label="success-text"]');

    const setClass = "show"
    var inputValidState = false;
    
    $form.on('submit', function (e) {
      e.preventDefault();
      
      if ($newsLetterInput.val() && inputValidState) {
        var klaviyoListId = $newsLetterInput.attr('data-klaviyo-list-id');
        var email = $(this).find('[type="email"]').val() || '';
        var data = {
          method: 'POST',
          headers: {revision: '2024-02-15', 'content-type': 'application/json'},
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Newsletter form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                    }
                  }
                }
              },
              relationships: {list: {data: {type: 'list', id: klaviyoListId}}}
            }
          })
        }

        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=VRXNff`, data)
          .then(response => {
             if (response.status === 202) {
               $submitInputButton.addClass(setClass).css('pointer-events', 'none').attr('c', 'disabled');

               gtag("event", "sign_up", {
                 method: "Newsletter footer form"
               });

               if ($successMessage) {
                 $successMessage.text($successMessage.attr("data-success"));
                 $successMessage.show();
               }

               if ($successText) {
                 $successText.text($successText.attr('data-success-text'));
               }
             } else {
               $inputError.addClass(setClass);
               $validError.removeClass(setClass)
               $serverError.addClass(setClass);
             }
          })
          .catch(err => {
            console.error(err);
            $inputError.addClass(setClass);
            $validError.removeClass(setClass)
            $serverError.addClass(setClass);
          });
      } else {
        $serverError.removeClass(setClass);
        $inputError.addClass(setClass);
        $validError.addClass(setClass);  //server hide, valid show
        $submitInputButton.attr('disabled', 'disabled');
      }
    })
    
    function inputValidation() {
      $submitInputButton.removeClass('btnFocus')
      $inputError.removeClass(setClass); //error hide
      $submitInputButton.removeClass(setClass).css('pointer-events', 'auto');
      
      var val = $newsLetterInput.val();
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var result = re.test(val);
      
      if (!result && !val == "") {
        $serverError.removeClass(setClass); // server hide, valid show
        $inputError.addClass(setClass);
        $validError.addClass(setClass)
        $submitInputButton.attr('disabled', 'disabled')
        // $inputError.focus();

      } else {
        inputValidState = true
        $submitInputButton.removeAttr('disabled')
      }
      if ($newsLetterInput.val() === '') {
        $inputError.removeClass(setClass)
      }
    }
    
    const returnetFunction = debounce(function () {
      inputValidation()
    }, 450)
    
    $newsLetterInput.on('input', function () {
      if ($(this).val() !== '') {
        $submitInputButton.addClass('active')
      } else {
        $submitInputButton.removeClass('active')
      }
      $inputError.removeClass(setClass)
      returnetFunction()
    })
  }
}

customElements.define('newsletter-form', NewsLetterForm)

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.minValue = this.input.getAttribute('min');
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const thisPlus = $(this).find('[name="plus"]');
    const thisMinus = $(this).find('[name="minus"]');
    const maxQuantity = +($(this).find('[name="plus"]').attr("data-max-quantity"));

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (!this.classList.contains('cart-quantity')) {
      this.disableButtons(this.input.value, thisMinus, thisPlus, maxQuantity);
    }

    if ($(this).hasClass('Product__Quantity') && $('.Product__Quantity').not(this).length) {
      const minusBtn = $('.Product__Quantity [name="minus"]').not(thisMinus);
      const plusBtn = $('.Product__Quantity [name="plus"]').not(thisPlus);

      $('.Product__Quantity .quantity__input').val(this.input.value);
      this.disableButtons(this.input.value, minusBtn, plusBtn, maxQuantity);
    }
  }

  disableButtons (currentValue, btnMinus, btnPlus, maxQuantity) {
    currentValue == this.minValue ? btnMinus.addClass("quantity__button-disabled") : btnMinus.removeClass("quantity__button-disabled");
    currentValue >= maxQuantity ? btnPlus.addClass("quantity__button-disabled") : btnPlus.removeClass("quantity__button-disabled");
  }
}

customElements.define('quantity-input', QuantityInput);


function debounce(func, wait) {
  var timeout = null;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      func.apply(context, args);
    }, wait || 0);
  };
}


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
    document.body.appendChild(form),
    form.submit(),
    document.body.removeChild(form)
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.isAutoplay = this.hasAttribute('data-autoplay');
    console.log(poster, 'poster')
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.isAutoplay) this.loadContent();
  }

  loadContent() {
    console.log('click')
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();

      if (this.isAutoplay) {
        const video = this.querySelector('video');
        if (video) video.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const formId = (this.dataset.prefix) ? this.dataset.section + this.dataset.prefix : this.dataset.section;
    const productForms = document.querySelectorAll(`#product-form-${formId}, #product-form-installment`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `#price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const selectors = {
          price: id,
          quantity: '.product-form__quantity',
          stickyBar: '.ProductStickyBar__FormWrapper',
          variantOptions: 'variant-radios',
          subscriptionPrice: '.SubscriptionWidget__SubsPrice',
          subscriptionPriceVariant: '.SubscriptionWidget__OTPPrice',
          productMedia: '.Product__MediaWrapper'
        }
        const selectorsValues = Object.values(selectors);
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        selectorsValues.forEach((item) => {
            let destination = document.querySelector(item);
            let source = html.querySelector(item);
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        )
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        sliderInit();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const formWrapper = document.getElementById(`product-form-wrapper-${this.dataset.section}`);

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if(formWrapper) formWrapper.classList.add('disabled');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if(formWrapper) formWrapper.classList.remove('disabled');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CollapsibleTabs extends HTMLElement {
  constructor() {
    super();
    this.eventListener();
  }

  eventListener() {
    const $wrapper = $(this);

    $wrapper.on('click', '.CollapsibleTabs__Button', function () {
      const $thisItem = $(this).parents('.CollapsibleTabs__Item');
      const $thisContent = $thisItem.find('.CollapsibleTabs__Content');
      const $items = $wrapper.find('.CollapsibleTabs__Item').not($thisItem);
      const $contents = $wrapper.find('.CollapsibleTabs__Content').not($thisContent);

      $items.attr('aria-expanded', 'false');
      $contents.attr('aria-hidden', 'true');
      $contents.slideUp();
      $thisContent.slideToggle();
      $thisItem.attr('aria-expanded', $thisItem.attr('aria-expanded') === 'false' ? 'true' : 'false');
      $thisContent.attr('aria-hidden', $thisContent.attr('aria-hidden') === 'false' ? 'true' : 'false');

    })
  }
}

customElements.define('collapsible-tabs', CollapsibleTabs);


class AgePopup extends HTMLElement {
  constructor() {
    super();
    this.active = false;
    this.mount();
    this.querySelectorAll("a[href='#confirm']").forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
        this.setAgeConfirmation();
      })
    });
  }

  mount() {
    this.init();
  }

  init() {
    if (!this.getAgeConfirmation()) {
      this.show();
    }
  }

  show() {
    if (!this.active) {
      this.active = true;
      this.classList.add('is-active');
    }
  }

  close() {
    if (this.active) {
      this.active = false;
      this.classList.remove('is-active');
      this.remove();
    }
  }

  setAgeConfirmation(isConfirmed = true) {
    sessionStorage.setItem('age_confirmation', isConfirmed.toString());
  }

  getAgeConfirmation() {
    return sessionStorage.getItem('age_confirmation') === 'true';
  }
}

customElements.define('age-popup', AgePopup);

if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.purchaseOptions = this.querySelectorAll('[name^="purchase-type-"]');
      this.purchaseOptionsOneTime = this.querySelectorAll('[value="one-time"]');


      if (this.purchaseOptions) {
        this.purchaseOptions.forEach((item) => {item.addEventListener('change', this.onPurchaseChange.bind(this))})
        setTimeout(() => {
          this.purchaseOptionsOneTime.forEach(elem => {elem.click()}); // Select one time purchase by default on page load
        }, 100)
      }

    }

    onPurchaseChange() {
      const checkedPurchaseValue = this.querySelector('[name^="purchase-type-"]:checked').value;
      const planQuantity = this.querySelector('[name^="purchase-type-"]:checked').getAttribute('data-quantity');

      this.updateInfo(checkedPurchaseValue);
      this.updateForm(checkedPurchaseValue, planQuantity);
    }

    updateInfo(purchase) {
      const subscriptionInfo = this.querySelector('.CardItem__SellingInfo');
      const subscriptionPrice = this.querySelector('.CardItem__SubscrPrice')
      const oneTimePrice = this.querySelector('.CardItem__OneTimePrice');

      if (purchase === 'subscription') {
        subscriptionInfo.classList.remove('hidden');
        subscriptionPrice.classList.remove('hidden');
        oneTimePrice.classList.add('hidden');
      } else {
        subscriptionInfo.classList.add('hidden');
        subscriptionPrice.classList.add('hidden');
        oneTimePrice.classList.remove('hidden');
      }
    }

    updateForm(purchase, planQuantity) {
      const sellingPlanInput = this.querySelector('[name="selling_plan"]');
      const sellingPropertyInput = this.querySelector('[name^="properties"]');
      const quantityInput = this.querySelector('.quantity__input');

      quantityInput.value = planQuantity;

      if (purchase === 'subscription') {
        sellingPlanInput.removeAttribute('disabled');
        sellingPropertyInput.removeAttribute('disabled');

      } else {
        sellingPlanInput.setAttribute('disabled', 'disabled');
        sellingPropertyInput.setAttribute('disabled', 'disabled');
      }
    }

  }

  customElements.define('product-card', ProductCard);
}

class SubscriptionForm extends HTMLElement {
  constructor() {
    super();

    this.initSubscriptionForm();
    this.initTooltip();

    this.sellingPlansGroups = this.querySelector('.SubscriptionWidget__Main');
    this.sellingPlansGroups.addEventListener('change', ()=> this.initSubscriptionForm())
  }

  initSubscriptionForm () {
    this.getSellingPlanGroupId();
    this.checkActiveSellingPlanGroup();
    if (this.dataset.updatePrice === 'true') this.renderPrice();
  }

  initTooltip() {
    const tooltipLabel = this.querySelector('.SubscriptionWidget__Info');

    if (!tooltipLabel) return

    tooltipLabel.addEventListener('mouseenter', () => this.toggleTooltip('show'));
    tooltipLabel.addEventListener('mouseleave', () => this.toggleTooltip('hide'));
    tooltipLabel.addEventListener('click', () => this.toggleTooltip('show'));
    document.addEventListener('click', (e) => {
      if (!tooltipLabel.contains(e.target) && e.target !== tooltipLabel && !e.target.classList.contains('SellingPlanGroupInput')) this.toggleTooltip('hide')
    });

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape')  this.toggleTooltip('hide');
    })
  }

  toggleTooltip(action) {

    const tooltipText =   this.querySelector('.SubscriptionWidget__TooltipText')

    if (!tooltipText) return
    action === 'show' ? tooltipText.classList.remove('hidden') : tooltipText.classList.add('hidden');
  }

  getSellingPlanGroupId() {
    const inputs = Array.from(this.querySelectorAll('[name="selling-plan-groups"]'));
    this.sellingPlanGroupId = Array.from(inputs).find((radio) => radio.checked).value;
    return this.sellingPlanGroupId
  }

  checkActiveSellingPlanGroup() {
    this.currentVariant = JSON.parse(this.querySelector('.current-variant-json').textContent)

    const sellingPlanGroup = this.querySelector('.SubscriptionWidget__SellingPlans');
    const sellingPlanGroupInputs = this.querySelectorAll('[name="selling_plan"]');

    if (this.sellingPlanGroupId) {
      let checkedPlan = this.querySelector('[name="selling_plan"]:checked') || this.querySelector('[name="selling_plan"]')

      checkedPlan.checked = true
      const planID = checkedPlan.value

      sellingPlanGroup.classList.remove('hidden')
      sellingPlanGroupInputs.forEach(item => {item.removeAttribute('disabled')});

      if (this.dataset.updateUrl === 'true') this.updateURL('add', planID)
    } else {
      sellingPlanGroup.classList.add('hidden')
      sellingPlanGroupInputs.forEach(item => {item.setAttribute('disabled', 'disabled')});

      if (this.dataset.updateUrl === 'true') this.updateURL('remove')
    }
  }

  updateURL(action, planID) {
    const location = window.location.href;
    const url = new window.URL(location);
    const params = url.searchParams;
    (action === 'add') ? params.set('selling_plan', planID) : params.delete('selling_plan')
    url.search = params.toString();
    this.url = url;
    window.history.replaceState({path: url.toString()}, '', url.toString());
  }

  renderPrice() {
    this.url.searchParams.set('variant', this.currentVariant.id);
    this.url.searchParams.set('section_id', this.dataset.section);

    fetch(`${this.url.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sellingPlanSelectors = ['selling-plan-group-price', 'selling-plan-group-sale-price'];

        sellingPlanSelectors.forEach(component => {
          const selector = `.${component}--${this.dataset.section}`;
          changeContentBySelector(selector, html);
        })
      });
  }
}

customElements.define('subscription-form', SubscriptionForm);


class customSelect extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.js-custom-select-btn');
    this.options = this.querySelectorAll('.js-custom-select-dropdown li');
    this.selectHidden = this.querySelector('.js-custom-select-hidden');
    this.selectType = this.dataset?.selectType;

    this.button.addEventListener('click',(e) => {
      if (this.classList.contains('open')) {
        this.classList.remove('open');
        e.target.setAttribute('aria-expanded', 'false');
        this.dispatchEvent(new CustomEvent('closeCustomSelect', {bubbles: true, detail: {selectType: this.selectType}}));
      } else {
        this.classList.add('open');
        e.target.setAttribute('aria-expanded', 'true');
        this.dispatchEvent(new CustomEvent('openCustomSelect', {bubbles: true, detail: {selectType: this.selectType}}));
      }
    });

    this.options.forEach(option => {
      const callback = (e) => {

        this.classList.remove('open');
        this.button.setAttribute('aria-expanded', 'false');

        if (e.target.classList.contains('checked')) return false;

        this.options.forEach(option => option.classList.remove('checked'));
        this.classList.add('checked');
        e.target.classList.add('checked');
        this.button.innerHTML = e.target.innerHTML;
        this.selectHidden.value = e.target.getAttribute('data-option-value');

        if (e.type === 'changeValue') return false;

        this.selectHidden.dispatchEvent(new CustomEvent('change', { bubbles: true }));
        this.selectHidden.dispatchEvent(new CustomEvent('changeCustomSelect', {bubbles: true, detail: {selectType: this.selectType}}));
      };

      option.addEventListener('click', callback);
      option.addEventListener('changeValue', callback);
    })

    document.addEventListener('click', (e) => {
      let isClickInside = this.contains(e.target);
      if (!isClickInside) {
        this.classList.remove('open');
        e.target.setAttribute('aria-expanded', 'false');
        this.dispatchEvent(new CustomEvent('closeCustomSelect', {bubbles: true, detail: {selectType: this.selectType}}));
      }
    });
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', customSelect);
}


$(function () {
  AOS.init({once: true, duration: 1100, offset: 50});
  headerDriver();
  initWidthMarquee()
  orientationDeviceListener()
  clickCardItems();
  sliderInit();
  yotpoReviews()
  popup()
  shopAll()
  headerHeightVariable()
  clickOutside()
  emailValidation()
  anchorLinkScroll()
  setTimeout(setMetafieldBirthday, 100)
})